import React, { useEffect, useRef, useState } from "react";
import { Icon } from "@culturehq/components";
import { Trans, t } from "app/utils";
import StoryTrendSummary from "components/stories/StoryTrendSummary";
import { usePostStoryContext } from "../../contexts/PostStoryContext";

const StoryInstructions = () => {
  const instructionsTextRef = useRef<HTMLParagraphElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const { state: { selectedPrompt } } = usePostStoryContext();
  const instructions = selectedPrompt?.summary;
  const prompt = selectedPrompt?.question || t("Instructions");

  const handleTextOverFlow = () => {
    const instructionsText = instructionsTextRef.current;
    if (instructionsText) {
      const overflowing = instructionsText.scrollHeight > instructionsText.clientHeight;

      setIsOverflowing(overflowing);
    }
  };

  useEffect(() => {
    handleTextOverFlow();
    window.addEventListener("resize", handleTextOverFlow);
    return () => {
      window.removeEventListener("resize", handleTextOverFlow);
    };
  }, []);

  return (
    <div className="InstructionsContainer">
      <Icon icon="info-v2-filled" />
      <div>
        <p ref={instructionsTextRef} className="InstructionsContainer-Text">
          <Trans>{instructions}</Trans>
        </p>
        {isOverflowing && (
          <StoryTrendSummary prompt={prompt} summary={instructions} title="Prompt Instructions" />
        )}
      </div>
    </div>
  );
};

export default StoryInstructions;
